export default __webpack_public_path__ + "static/media/about-main.bc04ac14.jpg";